import { useEffect, useState, useMemo, useContext, useCallback } from "react";
import { MDBRow, MDBCol } from "mdbreact";
import {
	MRT_ShowHideColumnsButton,
	MRT_ToggleFiltersButton,
	MRT_ToggleGlobalFilterButton,
	MaterialReactTable,
	useMaterialReactTable,
} from "material-react-table";
import { Box, IconButton, Tooltip } from "@mui/material";

import "./PortCode.scss";

import {
	ICONS,
	Button,
	Icon,
	Modal,
	AbsCheckBox,
	COLORS,
} from "abs-ui-components";

import AbsModal from "../../../common/absModal/AbsModal";
import Loader from "../../../common/Loader/Loader";
import { emitToasterMsg } from "../../../services/toasterUtility";
import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import AddPortCode from "../AddPortCode/AddPortCode";
import {
	DeletePortCodes,
	exportPortCodes,
	getPortCodes,
	DeletePortCodeConfirmationForVesselOrVoyage,
} from "../../../services/PortCodeService";
import {
	BREAD_CRUMB_PORT_CODES,
	COUNTRY_CODE_HEADER,
	COUNTRY_NAME_HEADER,
	EXPORT_ALL_PORTCODES,
	IS_EUPORT_HEADER,
	IS_TRANSHIPMENT,
	IS_UK_HEADER,
	IS_OMR__HEADER,
	IS_SMALLISLAND_HEADER,
	IS_TRANSNATIONAL_HEADER,
	PORT_CODE_HEADER,
	PORT_NAME_HEADER,
	PORTCODE_DELETE_CONFIRMATION_TEXT,
	PORTCODE_ASSOCIATED_WITH_VESSEL_OR_VOYAGE_VALIDATION_TEXT,
	IS_FEU_PORT,
	IS_FEU_TRANSHIPMENT,
	IS_FEU_SMALL_ISLAND,
	IS_FEU_OMR,
	IS_FEU_TRANSNATIONAL,
	IS_FEU_OMR_21,
	IS_FEU_OMR_24,
	IS_FEU_TRANSNATIONAL_25,
	IS_FEU_TRANSNATIONAL_26,
	THETIS_COUNTRY_HEADER,
	IS_NI_PORT,
	TERRITORY_HEADER, 
} from "../PortCodesConstant";

import { ADD, CANCEL, DELETE } from "../../../constants/CommonConstants";
import { useSelector } from "react-redux";
import { ClaimsContext } from "../../../services/ClaimsService";
import { ClaimType } from "../../../constants/claims";
import { FeatureType } from "../../../constants/FeatureToggles";
import ClearIcon from "@mui/icons-material/Clear";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

const SelectTextField = ({ header, accessorKey, updateFilterValue }) => {
	return {
		header: header,
		accessorKey: accessorKey,

		Filter: ({ column }) => {
			const value = column.getFilterValue() ?? "";

			return (
				<TextField
					select
					fullWidth
					variant="standard"
					value={value}
					onChange={(event) => {
						updateFilterValue(column.id, event.target.value);
					}}
					SelectProps={{
						displayEmpty: true,
						renderValue: (selected) =>
							selected === ""
								? (
									<span style={{ color: "#96a7b9", textOverflow: "ellipsis" }}>
										Filter by {header}
									</span>
								)
								: selected,
					}}


					InputProps={{
						endAdornment: (
							<InputAdornment
								position="end"
								sx={{
									position: "absolute",
									right: "24px",
									margin: 0,
									zIndex: 1,
									pointerEvents: "none",
								}}
							>
								<Tooltip
									title="Clear filter"
									placement="right"
									componentsProps={{
										tooltip: {
											sx: {
												backgroundColor: "dim gray",
												color: "#fff",
											},
										}
									}}
								>
									<IconButton
										size="small"
										onClick={(event) => {
											event.stopPropagation();
											column.setFilterValue(undefined);
										}}
										onMouseDown={(event) => {
											event.stopPropagation();
										}}
										sx={{
											color: "white",
											padding: "2px",
											pointerEvents: "auto",
										}}
										aria-label="Clear filter"
									>
										<ClearIcon fontSize="small" />
									</IconButton>
								</Tooltip>
							</InputAdornment>
						),
					}}

					sx={{
						"& .MuiInputBase-root": {
							color: "white",
							position: "relative",
						},
						"& .MuiInputBase-input": {
							color: "white",
						},
						"& .MuiSelect-icon": {
							color: "white",
							right: 0,
							width: "24px",
							height: "24px",
							pointerEvents: "none",
						},
						"& .MuiInput-root:before": {
							borderBottomColor: "white",
						},
						"& .MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before": {
							borderBottomColor: "white",
						},
						"& .MuiInput-root:after": {
							borderBottomColor: "white",
						},
						"& .MuiSvgIcon-root": {
							color: "white",
						},
						"& .MuiSelect-select": {
							paddingRight: "52px !important",
						},
					}}

				>
					<MenuItem value="true">true</MenuItem>
					<MenuItem value="false">false</MenuItem>
				</TextField>
			);
		},

		Cell: ({ row: { original } }) =>
			original[accessorKey] ? (
				<div className="checkbox-container">
					<AbsCheckBox checked={original[accessorKey]} />
				</div>
			) : (
				<AbsCheckBox />
			),
	}
}

const PortCode = () => {
	const { userHasClaim, userHasFeature } = useContext(ClaimsContext);
	const [addEditPortCodeModal, setAddEditPortCodeModal] = useState(false);
	const [confirmDelete, setConfirmDelete] = useState(false);
	const [portCodeList, setPortCodeList] = useState([]);
	const [editPortCode, setEditPortCode] = useState(null);
	const [loader, setLoader] = useState(false);
	const [type, setType] = useState("Add");
	const [loading, setLoading] = useState(true);
	const [exportLoading, setExportLoading] = useState(false);
	const [rowCount, setRowCount] = useState(0);
	const [portCodeSearchValue, setPortCodeSearchValue] = useState("");
	const [portCodeRowSelection, setPortCodeRowSelection] = useState({});
	const [portCodeSort, setPortCodeSort] = useState([]);
	const [portCodeColumnFilters, setPortCodeColumnFilters] = useState([]);
	const [portCodePagination, setPortCodePagination] = useState({
		pageIndex: 0,
		pageSize: 25,
	});
	const [pendingPortCodeColumnFilters, setPendingPortCodeColumnFilters] = useState([]);
	const [selectAll, setSelectAll] = useState(false);
	const [previousGlobalFilter, setPreviousGlobalFilter] = useState("");
	const [exportPortCodeEnabled, setExportPortCodeEnabled] = useState(true);
	const [
		portCodeAssociatedWithVesselOrVoyage,
		setPortCodeAssociatedWithVesselOrVoyage,
	] = useState(false);

	const user = useSelector((state) => state.userInfo.userData);

	const isMngPrtCdsFeatEnabled = typeof userHasFeature === "function"
		? userHasFeature(FeatureType.ManagePortCodes)
		: false;

	const[searchInput, setSearchInput] = useState("");

	useEffect(() => {
		let sortOptions = portCodeSort.map((x) => ({
			sortField: x.id,
			isAscending: !x.desc,
		}));

		if (portCodeColumnFilters.length > 0) {
			let updatedColumnFilter = portCodeColumnFilters.map((columnObj) => {
				if (
					columnObj.id === "IsEuPort" ||
					columnObj.id === "IsUkPort" ||
					columnObj.id === "IsTransShipment" ||
					columnObj.id === "IsSmallIsland" ||
					columnObj.id === "IsOmr" ||
					columnObj.id === "IsTransnational" ||
					columnObj.id === "IsFeuTransshipment" ||
					columnObj.id === "IsFeuSmallIsland" ||
					columnObj.id === "IsFeuOmr" ||
					columnObj.id === "IsFeuTransnational" ||
					columnObj.id === "IsFeuPort" ||
					columnObj.id === "IsFeuOmr21" ||
					columnObj.id === "IsFeuOmr24" ||
					columnObj.id === "IsFeuTransnational25" ||
					columnObj.id === "IsFeuTransnational26" ||
					columnObj.id === "IsNiPort"

				) {
					return {
						key: columnObj.id,
						value: columnObj.value === "true" ? true : false,
					};
				}
				return { key: columnObj.id, value: columnObj.value };
			});
			// setPortCodePagination((prev) => ({ ...prev, pageIndex: 0 }));
			searchPortCodes(
				portCodeSearchValue,
				portCodePagination.pageIndex,
				portCodePagination.pageSize,
				sortOptions,
				updatedColumnFilter
			);
		} else {
			if (
				portCodeSearchValue !== "" &&
				previousGlobalFilter !== portCodeSearchValue
			) {
				setPreviousGlobalFilter(portCodeSearchValue);
				setPortCodePagination({ ...portCodePagination, pageIndex: 0 });
				searchPortCodes(
					portCodeSearchValue,
					0,
					portCodePagination.pageSize,
					sortOptions,
					portCodeColumnFilters
				);
			} else {
				searchPortCodes(
					portCodeSearchValue,
					portCodePagination.pageIndex,
					portCodePagination.pageSize,
					sortOptions,
					portCodeColumnFilters
				);
			}
		}
	}, [
		portCodeSearchValue,
		portCodePagination.pageIndex,
		portCodePagination.pageSize,
		portCodeColumnFilters,
		portCodeSort,
	]);

	const toggleOpen = () => {
		setEditPortCode(null);
		setType("Add");
		setAddEditPortCodeModal(!addEditPortCodeModal);
	};

	const searchPortCodes = async (
		searchStr = "",
		pageIndex = 0,
		pageSize = 25,
		sortOptions,
		columnFilterValue
	) => {
		let requestPayload = {
			globalFilter: "",
			filters: [],
			pagination: {
				page: pageIndex + 1,
				pageSize: pageSize,
			},
			sortOption: {
				sortField: "",
				isAscending: false,
			},
		};

		if (searchStr !== "") {
			requestPayload.globalFilter = searchStr;
			// adding the seach query only when needed
		}

		if (sortOptions?.length) {
			requestPayload.sortOption = sortOptions[0];
		}

		if (columnFilterValue?.length) {
			requestPayload.filters = columnFilterValue;
		}

		try {
			setLoading(true);
			let response = await getPortCodes(requestPayload);
			if (response?.Data) {
				setPortCodeList(response.Data);
				setRowCount(response?.Pagination?.TotalItems);
				setPortCodeRowSelection({});
			}
		} catch (error) {
			setPortCodeList([]);
		} finally {
			setLoading(false);
		}
	};

	// patching portcode while editing
	const handleEditPortCode = (patchPortCodeValues) => {
		toggleOpen();
		const editPortCodeValues = patchPortCodeValues.original;
		const { CountryName, Alpha3Code, CountryMstId } =
			editPortCodeValues?.CountryMst;
		const country = {
			alpha3Code: Alpha3Code,
			countryName: CountryName,
			countryMstId: CountryMstId,
		};

		const patchPortCodes = {
			portName: editPortCodeValues?.PortName,
			portCode: editPortCodeValues?.PortCode,
			country: country,
			additionalData: editPortCodeValues?.AdditionalData,
			isEuPort: editPortCodeValues?.IsEuPort,
			isUkPort: editPortCodeValues?.IsUkPort,
			isSmallIsland: editPortCodeValues?.IsSmallIsland,
			isOmr: editPortCodeValues?.IsOmr,
			isTransnational: editPortCodeValues?.IsTransnational,
			isDcsPort: editPortCodeValues?.isDcsPort,
			isTerritory: editPortCodeValues?.IsTerritory,
			territory: editPortCodeValues?.Territory,
			portCodeMstId: editPortCodeValues?.PortCodeMstId,
			isTransShipment: editPortCodeValues?.IsTransShipment,
			isFeuTransshipment: editPortCodeValues?.IsFeuTransshipment,
			isFeuSmallIsland: editPortCodeValues?.IsFeuSmallIsland,
			isFeuOmr21: editPortCodeValues?.IsFeuOmr21,
			isFeuOmr24: editPortCodeValues?.IsFeuOmr24,
			isFeuTransnational25: editPortCodeValues?.IsFeuTransnational25,
			isFeuTransnational26: editPortCodeValues?.IsFeuTransnational26,
			isFeuPort: editPortCodeValues?.IsFeuPort,
			thetis: editPortCodeValues?.Thetis,
		};
		setEditPortCode(patchPortCodes);
		setType("Edit");
	};

	// deleting selected portcodes
	const handleDeletePortCodes = async () => {
		//let portCodeIds = Object.keys(portCodeRowSelection).map(Number);
		let portCodeIds = portCodeRowSelection;
		try {
			let response = await DeletePortCodes(portCodeIds);
			if (response.isSuccess) {
				searchPortCodes();
				setPortCodeRowSelection([]);
				setConfirmDelete(false);
				//showing success toaster
				emitToasterMsg("success", "Port Code", "Deleted Successfully");
			} else {
				emitToasterMsg(
					"error",
					"Port Code",
					"Failed to delete port code(s)"
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleExportPortCodeTable = async () => {
		setExportLoading(true);
		setExportPortCodeEnabled(false);
		try {
			let response = await exportPortCodes();
			if (response.status === 200) {
				const blob = new Blob([response.data], {
					type: response.headers["content-type"],
				});
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "ABS-Port-List-Export.xlsx");
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				emitToasterMsg(
					"success",
					"Export  Portcode(s)",
					"Exported Successfully!"
				);
				setExportPortCodeEnabled(true);
			} else {
				emitToasterMsg(
					"error",
					"Export  Portcodes",
					"Failed to Export Port Codes"
				);
				setExportPortCodeEnabled(true);
			}
		} catch (error) {
			console.error("Failed to Export Port Codes", error);
			emitToasterMsg(
				"error",
				"Export Portcodes",
				"An error occurred while exporting."
			);
			setExportPortCodeEnabled(true);
		} finally {
			setExportLoading(false);
			setExportPortCodeEnabled(true);
		}
	};

	const handleIsPortCodeAssociatedWithVoyageOrVessel = async (portCodeId) => {
		try {
			setPortCodeRowSelection([portCodeId]);
			const { isSuccess } =
				await DeletePortCodeConfirmationForVesselOrVoyage(portCodeId);
			setPortCodeAssociatedWithVesselOrVoyage(isSuccess);
			setConfirmDelete(true);
		} catch (error) {
			console.error("Error in handling port code association:", error);
		}
	};

	const handleSelectAll = (event) => {
		setSelectAll(event.target.checked);
	};

	const applyFilters = useCallback(() => {

		setPortCodePagination((prev) => ({
			...prev,
			pageIndex: 0,
		}));

		setPortCodeColumnFilters([
			...pendingPortCodeColumnFilters,
		]);

		setPortCodeSearchValue(searchInput);

	}, [pendingPortCodeColumnFilters, searchInput]);

	const resetFilterForColumn = useCallback((columnId) => {

		setPortCodePagination((prev) => ({
			...prev,
			pageIndex: 0,
		}));

		setPortCodeColumnFilters((prev) =>
			prev.filter((f) => f.id !== columnId)
		);

	}, []);

	const handleColumnFiltersChange = useCallback(
		(updater) => {

			setPendingPortCodeColumnFilters((prev) => {

				const updated =
					typeof updater === "function"
						? updater(prev)
						: updater;

				// detect removed filters
				prev.forEach((oldFilter) => {

					const stillExists = updated.some(
						(newFilter) =>
							newFilter.id === oldFilter.id
					);

					if (!stillExists) {

						// ONLY if previously applied
						const wasApplied =
							portCodeColumnFilters.some(
								(f) => f.id === oldFilter.id
							);

						if (wasApplied) {
							resetFilterForColumn(oldFilter.id);
						}
					}
				});

				return updated;
			});
		},
		[portCodeColumnFilters, resetFilterForColumn]
	);

	const updateFilterValue = useCallback(
		(columnId, value) => {

			setPendingPortCodeColumnFilters((prev) => {

				const normalizedValue =
					value?.trim?.() ?? "";

				const others = prev.filter(
					(f) => f.id !== columnId
				);

				const updatedPending = normalizedValue
					? [
						...others,
						{
							id: columnId,
							value: normalizedValue,
						},
					]
					: others;

				// ONLY auto reset if filter was already applied
				const wasApplied =
					portCodeColumnFilters.some(
						(f) => f.id === columnId
					);

				if (!normalizedValue && wasApplied) {

					setPortCodePagination((prev) => ({
						...prev,
						pageIndex: 0,
					}));

					setPortCodeColumnFilters((prevApplied) =>
						prevApplied.filter(
							(f) => f.id !== columnId
						)
					);
				}

				return updatedPending;
			});
		},
		[portCodeColumnFilters]
	);

	const clearAllFilters = useCallback(() => {

		setPendingPortCodeColumnFilters([]);

		setPortCodeColumnFilters([]);

		setSearchInput("");

		setPortCodeSearchValue("");

		setPortCodePagination((prev) => ({
			...prev,
			pageIndex: 0,
		}));

	}, []);

		const portCodeColumns = useMemo(
		() => [
			{
				header: PORT_CODE_HEADER,
				enableHiding: false,
				accessorKey: "PortCode",
			},
			{
				header: PORT_NAME_HEADER,
				enableHiding: false,
				accessorKey: "PortName",
			},
			{
				header: COUNTRY_CODE_HEADER,
				accessorKey: "CountryMst.Alpha3Code",
			},
			{
				header: THETIS_COUNTRY_HEADER,
				accessorKey: "Thetis",
				Cell: ({ row: { original } }) =>
					original.IsThetis ? original.Thetis : ""
			},
			{
				header: COUNTRY_NAME_HEADER,
				accessorKey: "CountryMst.CountryName",
			},
			{
				header: "Territory",
				accessorKey: "Territory",
			},

			SelectTextField({ header: IS_EUPORT_HEADER, accessorKey: "IsEuPort", updateFilterValue }),
			SelectTextField({ header: IS_UK_HEADER, accessorKey: "IsUkPort",updateFilterValue }),
			SelectTextField({ header: IS_TRANSHIPMENT, accessorKey: "IsTransShipment", updateFilterValue }),
			SelectTextField({ header: IS_SMALLISLAND_HEADER, accessorKey: "IsSmallIsland", updateFilterValue }),
			SelectTextField({ header: IS_OMR__HEADER, accessorKey: "IsOmr", updateFilterValue }),
			SelectTextField({ header: IS_TRANSNATIONAL_HEADER, accessorKey: "IsTransnational", updateFilterValue }),
			SelectTextField({ header: IS_FEU_PORT, accessorKey: "IsFeuPort", updateFilterValue }),
			SelectTextField({ header: IS_FEU_TRANSHIPMENT, accessorKey: "IsFeuTransshipment", updateFilterValue }),
			SelectTextField({ header: IS_FEU_SMALL_ISLAND, accessorKey: "IsFeuSmallIsland", updateFilterValue }),
			SelectTextField({ header: IS_FEU_OMR_21, accessorKey: "IsFeuOmr21", updateFilterValue }),
			SelectTextField({ header: IS_FEU_OMR_24, accessorKey: "IsFeuOmr24", updateFilterValue }),
			SelectTextField({ header: IS_FEU_TRANSNATIONAL_25, accessorKey: "IsFeuTransnational25", updateFilterValue }),
			SelectTextField({ header: IS_FEU_TRANSNATIONAL_26, accessorKey: "IsFeuTransnational26", updateFilterValue }),
			SelectTextField({ header: IS_NI_PORT, accessorKey: "IsNiPort", updateFilterValue }),
		],
		[]
	);

	const portCodeTable = useMaterialReactTable({
		columns: portCodeColumns,
		data: portCodeList,
		manualSorting: true,
		enableStickyHeader: true,
		manualPagination: true,
		manualFiltering: true,
		rowCount,
		enableRowActions: userHasClaim(ClaimType.UPDATE_PORT_CODE) && isMngPrtCdsFeatEnabled,
		positionActionsColumn: "last",
		displayColumnDefOptions: {
			"mrt-row-actions": {
				header: "",
			},
		},
		getRowId: (row) => row.PortCodeMstId,
		onSortingChange: setPortCodeSort,
		onRowSelectionChange: setPortCodeRowSelection,
		onPaginationChange: setPortCodePagination,
		onGlobalFilterChange: (value) => {
			setSearchInput(value);
		},
		onColumnFiltersChange: handleColumnFiltersChange,
		state: {
			pagination: portCodePagination,
			globalFilter: searchInput,
			columnFilters: pendingPortCodeColumnFilters,
			isLoading: loading,
			sorting: portCodeSort,
		},
		initialState: {
			density: "compact",
			columnOrder: [
				"mrt-row-select",
				"mrt-row-actions",
				"PortCode",
				"PortName",
				"CountryMst.Alpha3Code",
				"Thetis",
				"CountryMst.CountryName",
				"Territory",
				"IsEuPort",
				"IsTransShipment",
				"IsOmr",
				"IsSmallIsland",
				"IsTransnational",
				"IsFeuPort",
				"IsFeuTransshipment",
				"IsFeuOmr21",
				"IsFeuOmr24",
				"IsFeuSmallIsland",
				"IsFeuTransnational25",
				"IsFeuTransnational26",
				"IsUkPort",
				"IsNiPort",
			],
		},
		muiPaginationProps: {
			rowsPerPageOptions: [25, 50, 75, 100],
			showFirstButton: true,
			showLastButton: true,
		},
		renderRowActions: ({ row, table }) => (
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					width: "100px",
				}}
			>
				<Tooltip title="Edit">
					<IconButton onClick={() => handleEditPortCode(row)}>
						<Icon
							icon={ICONS.EDIT}
							className="d-flex edit-port-code-icon"
							outline={true}
						/>
					</IconButton>
				</Tooltip>

				<Tooltip title="Delete">
					<IconButton
						color="error"
						onClick={() => {
							handleIsPortCodeAssociatedWithVoyageOrVessel(
								row.id
							);
						}}
					>
						<Icon
							color="#DA1F33"
							icon={ICONS.DELETE}
							className="d-flex edit-port-code-icon"
							outline={true}
						/>
					</IconButton>
				</Tooltip>
			</Box>
		),
		muiTableContainerProps: {
			sx: {
				maxHeight: "calc(100vh - 376px)",
			},
		},
		renderToolbarInternalActions: ({ table }) => (
			<>
				<MRT_ToggleGlobalFilterButton
					id="pc_view_global_search"
					table={table}
				/>
				<MRT_ShowHideColumnsButton
					id="pc_view_show_hide_Columns"
					table={table}
				/>
				<MRT_ToggleFiltersButton
					id="pc_view_global_filter"
					table={table}
				/>
				<Button
					className="ml-2"
					onClick={() => {
						applyFilters();
					}}
				>
					Apply Filters
				</Button>
				<Button
					className="ml-2"
					variant="secondary"
					onClick={clearAllFilters}
				>
					Clear
				</Button>
			</>
		),
		muiTableHeadCellProps: ({ column }) => ({
			id: `${column.columnDef.accessorKey}`,
			sx: {
				color: "rgb(255 255 255)",

				"& .MuiButtonBase-root": {
					color: "white !important",
					"& .MuiTableSortLabel-icon": {
						color: "white !important",
					},
				},
			},
		}),
		muiFilterTextFieldProps:  ({ column }) => ({
			sx: {
				"& .MuiInput-root": {
					color: "white !important",
				},
				"& .MuiButtonBase-root": {
					color: "white !important",
				},
				"& .MuiInputBase-root::after": {
					transform: "none",
					borderBottom: "2px solid white",
				},
				"& .MuiSvgIcon-root": {
					color: "white",
				},
			},
			onChange: (e) => {

				const value = e.target.value;

				updateFilterValue(column.id, value);
			},
			onKeyDown: (e) => {
				if (e.key === "Enter") {
					applyFilters();
				}
			},
		}),
		muiColumnActionsButtonProps: {
			sx: {
				color: "white",
			},
		},
		muiSelectAllCheckboxProps: {
			title: selectAll ? "Toggle deselect all" : "Toggle select all",
			onClick: (e) => handleSelectAll(e),
			sx: {
				color: "white",
			},
		},
		muiTableHeadRowProps: {
			sx: {
				backgroundColor: "#042a4c !important",

				"& .MuiTableCell-head::before": {
					backgroundColor: "#042a4c !important",
				},
			},
		},
		muiTablePaperProps: {
			sx: {
				boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
			},
		},

		muiSearchTextFieldProps: {
			placeholder: "Type and Enter",
			value: searchInput,
			onChange: (e) => {
				const value = e.target.value;
				setSearchInput(value);
				setPortCodePagination((prev) => ({ ...prev, pageIndex: 0 }));
				
				if (!value.trim()) {

					setPortCodePagination((prev) => ({
						...prev,
						pageIndex: 0,
					}));

					setPortCodeSearchValue("");
				}
			},
			onKeyDown: (e) => {
				if (e.key === "Enter" && searchInput.trim()) {
					applyFilters();
				}
			},
			InputProps: {
				endAdornment: searchInput && (
					<IconButton
						size="small"
						onClick={() => {
							setSearchInput("");
							setPortCodeSearchValue("");
							setPortCodePagination((prev) => ({ ...prev, pageIndex: 0 }));
						}}
						sx={{ visibility: searchInput ? "visible" : "hidden" }}
					>
						<ClearIcon fontSize="small" />
					</IconButton>
				),
			},
		},
	});

	const breadCrumb = useMemo(() => BREAD_CRUMB_PORT_CODES);
	return (
		<div className="port-codes-table">
			<BreadCrumb items={breadCrumb} />
			{(loader || exportLoading) && <Loader />}

			<MDBRow
				md="12"
				className="d-flex justify-content-between align-items-center pb-4"
			>
				<MDBCol md="12" className="d-flex justify-content-end">
					{userHasClaim(ClaimType.DELETE_PORT_CODE) && isMngPrtCdsFeatEnabled && (
						<div className="d-flex justify-content-end">
							<div id="pc_view_add_btn">
								<Button
									className="mr-2"
									onClick={toggleOpen}
									startIcon={<Icon icon={ICONS.ADD} />}
								>
									{ADD}
								</Button>
							</div>
							{/* <div id="pc_view_delete_btn">
								<Button
									disabled={
										Object.keys(portCodeRowSelection)
											.length == 0
									}
									className="mr-2 delete-btn"
									onClick={() => setConfirmDelete(true)}
									startIcon={<Icon icon={ICONS.DELETE} />}
								>
									{DELETE}
								</Button>
							</div> */}
						</div>
					)}
					<div id="pc_view_export_btn">
						<Button
							startIcon={
								exportLoading ? (
									<Icon icon="downloading" />
								) : (
									<Icon icon="ios_share" />
								)
							}
							onClick={handleExportPortCodeTable}
							className="mr-2"
							disabled={!exportPortCodeEnabled}
							variant="secondary"
						>
							{exportPortCodeEnabled
								? EXPORT_ALL_PORTCODES
								: "Please wait..."}
						</Button>
					</div>
				</MDBCol>
			</MDBRow>

			<MaterialReactTable table={portCodeTable} />
			{/* confirmation pop up for deleting portcodes */}
			<div md="6" className="confirmation-modal-container">
				<Modal
					isOpen={confirmDelete}
					showFooter
					modalHeader
					padding={"70px"}
					headerHeight={"50px"}
					onCloseClickListener={() => {
						setConfirmDelete(false);
					}}
					footer={
						<div className="d-flex justify-content-end fixed-action-btns p-4">
							<Button
								className="modal-delete-btn"
								onClick={handleDeletePortCodes}
								primaryColor={COLORS.RED.DARK}
								primaryBackgroundColor={COLORS.RED.LIGHT}
							>
								{DELETE}
							</Button>
							<Button
								className="modal-cancel-btn"
								onClick={() => {
									setConfirmDelete(false);
								}}
							>
								{CANCEL}
							</Button>
						</div>
					}
				>
					<div>
						{portCodeAssociatedWithVesselOrVoyage
							? PORTCODE_ASSOCIATED_WITH_VESSEL_OR_VOYAGE_VALIDATION_TEXT
							: PORTCODE_DELETE_CONFIRMATION_TEXT}
					</div>
				</Modal>
			</div>

			<AbsModal
				isOpen={addEditPortCodeModal}
				title={`${type} ${PORT_CODE_HEADER}`}
				onClose={setAddEditPortCodeModal}
				close={toggleOpen}
			>
				{addEditPortCodeModal && (
					<AddPortCode
						onRefetchPortCodes={() => searchPortCodes()}
						editPortCode={editPortCode}
						type={type}
						onClose={setAddEditPortCodeModal}
					/>
				)}
			</AbsModal>
		</div>
	);
};

export default PortCode;
